import { render, staticRenderFns } from "./index-manual.vue?vue&type=template&id=1e13f20e"
import script from "./index-manual.vue?vue&type=script&lang=js"
export * from "./index-manual.vue?vue&type=script&lang=js"
import style0 from "./index-manual.vue?vue&type=style&index=0&id=1e13f20e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports